import { Login } from 'modules/LoginModule/components/Login';
const LoginPage = () => {
  return (
    <div className="h-screen w-full">
      <Login />
    </div>
  );
};

export default LoginPage;
